import { render, staticRenderFns } from "./drop-zone.vue?vue&type=template&id=4f8dc105&scoped=true"
import script from "./drop-zone.vue?vue&type=script&lang=js"
export * from "./drop-zone.vue?vue&type=script&lang=js"
import style0 from "./drop-zone.vue?vue&type=style&index=0&id=4f8dc105&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8dc105",
  null
  
)

export default component.exports